import {ResponseModel} from '@app/marketplace/core/models/response.model';
import {TreeviewItem} from 'ngx-treeview';
import {CheckoutBaseInputModel} from '@app/marketplace/checkout/_models/checkout.model';
import {mod} from 'ngx-bootstrap/chronos/utils';

export interface PaymentProfileInterface {
  id: number;
  cardLastNumbers: string;
  description: string;
  type: number;
  typeToShow: string;
  default: boolean;
  required: PaymentProfileRequiredInterface;
  available: boolean;
  message: string;
  denomination: number;
}

export class PaymentVerificationModel {
  cardVerification: string;
  cvv: string;
  expirationDate?: ExpirationDateModel;
  firstSixDigits: string;
  zipCode: string;
}

export class ExpirationDateModel {
  month: number;
  year: number;
}

export interface PaymentProfileRequiredInterface {
  cardVerificationRequired: boolean;
  cvvRequired: boolean;
  expirationDateRequired: boolean;
  firstSixDigitsRequired: boolean;
  zipCodeRequired: boolean;
}

export class PurchaseInputModel extends CheckoutBaseInputModel {
  deliveryInstructions: string;
  checkoutId: string;
  constructor(model?) {
    model = model || {};
    super(model);
    this.deliveryInstructions = model.deliveryInstructions || '';
    this.checkoutId = model.checkoutId || '';
  }
}

export class PaymentProfilePurchaseInputModel extends PurchaseInputModel {
  paymentProfileId: number;
  cardNumber: string;
  zipCode: string;
  firstSixDigits: string;
  securityCode: string;
  expirationMonth?: number;
  expirationYear?: number;
  constructor(model?) {
    model = model || {};
    super(model);
    this.paymentProfileId = model.paymentProfileId || '';
    this.cardNumber = model.cardNumber || '';
    this.zipCode = model.zipCode || '';
    this.firstSixDigits = model.firstSixDigits || '';
    this.securityCode = model.securityCode || '';
    this.expirationMonth = model.expirationYear || '';
    this.expirationYear = model.expirationYear || '';
  }
}

export class CreditCardPurchaseInputModel extends PurchaseInputModel {
  cardHolderName: string;
  cardNumber: string;
  securityNumber: string;
  expirationMonth: number;
  expirationYear: number;
  zipCode: string;
  remember: boolean;

  constructor(model?) {
    model = model || {};
    super(model);
    this.cardHolderName = model.cardHolderName || '';
    this.cardNumber = model.cardNumber || '';
    this.securityNumber = model.securityNumber || '';
    this.expirationMonth = Number(model.expirationMonth);
    this.expirationYear = Number(model.expirationYear);
    this.zipCode = model.zipCode || '';
    this.remember = model.remember || false;
  }
}

export class TreeViewPayment extends TreeviewItem {
  type: number;
  required: PaymentProfileRequiredInterface;
}

export interface PaymentProfileCollection extends ResponseModel<Array<PaymentProfileInterface>> {
}

export interface CreditCardPayment extends BasePurchaseOutputInterface {
  redirectUrl: string;
  token: string;
  verificationType: CreditVerificationType;
  payerAuthRequest: string;
  merchantData: string;
  webviewUrl: string;
  callbackUrl: string;
  cardNumber: string;
  expirationYear: string;
  expirationMonth: string;
  totalAmount: string;
}

export interface CreditCardPaymentResponse extends ResponseModel<CreditCardPayment> {}
export interface AuthorizePaymentResponse extends ResponseModel<AuthorizePayment> {}

export interface BasePurchaseOutputInterface {
  orderNo: number;
  orderCode: string;
}
export interface AuthorizePayment extends BasePurchaseOutputInterface{
  attemptsRemaining: number;
}
export class ValidateCreditCardPaymentModel {
  token: string;
  orderCode: string;
  verificationCode: string;
}

export class Validate3SecureCard {
  orderCode: string;
  externalData: string;
}

export enum CreditVerificationType {
  /// <summary>
  /// No verification Required
  /// </summary>
  None = 0,
  /// <summary>
  /// System 2 Digits Verification
  /// </summary>
  DoingBusinessAs = 1,
  /// <summary>
  /// Secure 3D Verification
  /// </summary>
  Secure3D = 2,
  /// <summary>
  /// Secure 3D Verification
  /// </summary>
  Secure3DV2 = 3
}
